export const jobsiteDataLocators = {
    star_icon: 'star-icon',
    choose_jobsite_search_input: 'searchInput',
    choose_jobsite_cross_icon: 'crossIcon',
}